import type { AppDispatch } from '@frontend/web/redux';
import { useDispatch as useReactReduxDispatch } from 'react-redux';

export const useDispatch = () => useReactReduxDispatch<AppDispatch>();
